import React from "react";
import ReportListShipLost from "./ReportListShipLost";
import { AppConstant } from "const";

const ReportListShipLostSignal = ({ open, onClose }) => {
  return <ReportListShipLost open={open} onClose={onClose} lostType={AppConstant.SHIP_LOST_TYPE.lostSignal} />;
};

export default ReportListShipLostSignal;
